import initialState from "./initial.value";

const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case "User_Detail":
      return { ...state, user_detail: action.payload };
    default:
      return state;
  }
};

export default rootReducer;
